import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

export default{
    app: {
        title: '文献相似性检测服务',
        alias: '查大同 · 识小异',
        simple: '简明报告',
        origin: '原文标注报告',
        detail: '详细片段报告',
        full: '全文比对报告',
        preservation: '存档报告'
    },
    info: {
        paperInfo: '送检文献信息',
        title: '题名：',
        author: '作者',
        name: '姓名',
        stuNum: '学号',
        tutor: '导师',
        origin: '来源',
        receive: '收稿时间',
        receive2: '学位授予时间',
        checkTime: '检测时间',
        checkLimit: '检测范围',
        allPerc: '总相似比',
        referenceCopyPercent:'参考文献相似比',
        selfCopyPercent:'可能自引相似比'
    },
    cr: {
        result: '检测结果',
        word: '字',
        jian: '检',
        can: '参',
        zi: '自',
        fa: '法',
        zhuan: '专',
        validTextNum: '原文总字符数',
        fullTextNum: '检测字符数',
        refCopyPer: '参考文献相似比',
        exRefCopyPer: '排除参考文献相似比',
        selfCopyPer: '可能自引相似比',
        exSelfCopyPer: '排除自引相似比',
        lawsCopyPer: '法律法规文献相似比',
        exLawsCopyPer: '排除法律法规相似比',
        termsCopyPer: '专名术语相似比'
    },
    crd: {
        detailResult: '检测详情',
        paraNum: '原文总段落数',
        simiCount: '相似字符数',
        maxSimiScale: '单篇最大相似比',
        maxSimiNum: '单篇最大相似字符数',
        maxSimiTitle: '单篇最大相似文献',
        no: '无',
        tableNum:'识别表格数'
    },
    explain: {
        seal: '盖章处',
        reportIndex: '报告指标说明',
        indicators1: '原文总字符数：即送检文献的总字符数，包含文字字符、标点符号、阿拉伯数字（不计入空格）',
        indicators2: '检测字符数：送检文献经过系统程序处理，排除已识别的参考文献等不作为相似性比对内容的部分后，剩余全部参与相似性检测匹配的文本字符数',
        indicators3: '总相似比：送检文献与其他文献的相似文本内容在原文中所占比例',
        indicators4: '参考文献相似比：送检文献与其标明引用的参考文献的相似文本内容在原文中所占比例',
        indicators5: '可能自引相似比：送检文献与其作者本人的其他已公开或发表文献的相似文本内容在原文中所占比例',
        indicators6: '单篇最大相似比：送检文献的相似文献中贡献相似比最高一篇的相似比值',
        indicators7: '引用情况：该相似文献是否被送检文献标注为其参考文献引用，以及是否为可能自引文献',
        indicators8: '法律法规文献相似比：送检文献与“中国法律法规数据库”中文献的相似文本内容在原文中所占比例',
        indicators9: '专名术语相似比：相似文本中，“专用名词和专业术语”在原文中所占比例'
    },
    full: {
        colorIntro: '报告颜色标注说明',
        green: '绿色',
        refCopyPer: '代表参考文献相似比',
        yellow: '黄色',
        selfCopyPer: '代表可能自引相似比',
        red: '红色',
        other: '代表除参考文献及可能自引外的其他相似比',
        blue: '蓝色',
        lawCopyPer: '代表法律法规文献相似比',
        wfbc: '代表相似比',
        clickIntro: '请点击文档中有颜色标注的文本内容查看相似片段详情',
        isRef: '是否引用',
        yes: '自引',
        no: '未引用',
        refCited: '参考文献引用',
        similarPart: '相似文献片段',
        partSimiNum: '此片段相似字符数',
        reportId: '报告编号',
        originMark: '原文标注',
        unfold: '展开',
        fold: '收起'
    },
    fOrH: {
        intro: '检测报告由万方数据文献相似性检测系统算法生成，仅对您所选择的检测范围内检验结果负责，结果仅供参考',
        web: '万方检测官方网站',
        truth: '检测报告真伪验证官方网站',
        wf: '北京万方数据股份有限公司出品',
        oneReport: '一对一检测报告',
        downReport: '下载该报告',
        downing: '报告下载中，请耐心等待'
    },
    sign: {
        org: '送检机构（盖章）',
        signature: '签字处',
        subMan: '提交人',
        subOrg: '提交人所在单位',
        isWf: '送检论文是否为万方数据库内查找',
        inspector: '检索检测员',
        monitors: '监督员',
        yes: '是',
        no: '否',
    },
    simi: {
        simiList: '相似文献列表',
        listCount: '仅列举前{len}条',
        index: '序号',
        perc: '相似比(相似字符)',
        simiPaper: '相似文献',
        type: '类型',
        isRef: '引用情况',
        char: '字符',
        simiChart: '相似片段分布图',
        simiDetail: '相似片段详情',
        originPart: '送检原文片段',
        position: '位置'
    },
    one: {
        thanInfo: '比对文献信息',
        indicators1: '比对文献是否为参考文献：该比对文献是否被送检文献标注为其参考文献引用',
        indicators2: '比对文献是否可能为自引文献：比对文献作者是否与送检文献作者一致',
        thanPart: '比对文献片段'
    },
    error: {
        text1: '抱歉！您访问的页面不存在',
        text2: '请检查网址是否正确'
    },
    ...zhLocale
}